import { styled } from '@linaria/react';
import { primitives, semantic, size, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(calc(var(--gallery-index, 0) * -100%));
  transition: transform 0.35s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: calc(${space['space-600']} + var(--split-mobile-overlap, 0px));
  left: ${space['space-600']};
  right: ${space['space-600']};
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  z-index: 2;
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  padding: ${space['space-100']};
  background: ${semantic.bg.overlayBlur};
  backdrop-filter: blur(${size.blur['blur-lg']});
  border-radius: ${size.radius['radius-full']};

  svg {
    height: 11.31px;
    width: auto;
    color: ${semantic.text.inverse};
  }
`;

export const Dots = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
`;

export const Dot = styled.button`
  width: ${primitives.size['size-100']};
  height: ${primitives.size['size-100']};
  padding: 0;
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.secondary};
  opacity: 0.5;
  cursor: pointer;
  transition: width 0.2s ease;

  &[data-active='true'] {
    width: ${primitives.size['size-400']};
    opacity: 1;
  }
`;
